import { isMobile } from 'react-device-detect';
import styles from './InstagramFollowModal.module.css';
import { useEffect, useState } from 'react';
import api from '../../../../../api';

const InstagramFollowModal = ({devicePosition, platform}) => {
      const [currentRegion, setCurrentRegion] = useState('경북');

      const REGIONS = ['서울','부산','인천','대구','대전','광주','울산','세종','경기','충북','충남','전남','경북','경남','강원','전북','제주']
      const REGION_POSITION={
            '강원':[222,235],
            '경기':[198,128],
            '서울':[251,138],
            '인천':[246,80],
            '충북':[299,193],
            '세종':[313,134],
            '충남':[348,88],
            '대전':[356,169],
            '전북':[391,128],
            '광주':[445,121],
            '전남':[491,90],
            '제주':[593,85],
            '경북':[324,273],
            '대구':[383,249],
            '경남':[428,206],
            '부산':[450,283],
            '울산':[402,313],
      }
      const REGION_INSTAGRAM={
            '강원':'gangwon_hotple_kr',
            '경기':'gyeonggi_hotple_kr',
            '서울':'seoul_hotple_kr',
            '인천':'incheon_hotple_kr',
            '충북':'chungbuk_hotple_kr',
            '세종':'sejong_hotple_kr',
            '충남':'chungnam_hotple_kr_',
            '대전':'daejeon_hotple_kr_',
            '전북':'jeonbuk_hotple_kr',
            '광주':'gwangju_hotple_kr',
            '전남':'jeonnam_hotple_kr',
            '제주':'jeju_hotple_kr_',
            '경북':'gyeongbuk_hotple_kr',
            '대구':'daegu_hotple_kr',
            '경남':'gyeongnam_hotple_kr_',
            '부산':'busan_hotple_kr',
            '울산':'ulsan_hotple_kr',
      }

      const REGION_RECOMMEND={
            '강원':['서울','경기'],
            '경기':['서울','인천'],
            '서울':['인천','경기'],
            '인천':['서울','경기'],
            '충북':['세종','대전'],
            '세종':['대전','서울'],
            '충남':['세종','대전'],
            '대전':['세종'],
            '전북':['광주','전남'],
            '광주':['전남','전북'],
            '전남':['광주','전북'],
            '제주':['서울'],
            '경북':['대구','울산'],
            '대구':['경북','경남'],
            '경남':['대구','부산'],
            '부산':['대구','울산'],
            '울산':['대구','부산']
      }

      function isRecommended(region){
            return currentRegion == region || region == '제주' || REGION_RECOMMEND[currentRegion].includes(region);
      }

      function getPosition(region){
            return {top: `${REGION_POSITION[region][0] - (isMobile ?14:0)}px`, left: `${REGION_POSITION[region][1] - (isMobile?15:0) - (platform!='web'?16:0)}px`}
      }

      function whenRegionButtonClicked(region){
            window.open(`https://instagram.com/${REGION_INSTAGRAM[region]}`, '_blank');
            //클릭 수 집계
      }

      function regionImageComponent(region){
            return (
                  <div className={isRecommended(region) ? styles.regionFrameRecommended : styles.regionFrame} style={getPosition(region)}>
                        <img className={styles.region} alt="" src={`images/region_account/${region}.png`} onClick={()=>whenRegionButtonClicked(region)} />
                        {isRecommended(region) && <div className={styles.badge}>추천</div>}
                  </div>
            )
      }

      async function getCurrentRegion(){
            const result = await api.get(`/gis/reverse_geocode`,{
                  params: {
                        lat: devicePosition.lat,
                        long: devicePosition.long
                  }
            });

            if(result)
                  setCurrentRegion(result.data.address.slice(0,2));
      }

      useEffect(()=>{
            getCurrentRegion();
      },[]);

      return (
            <div className={styles.container}>
                  <div className={styles.header}>
                        <div className={styles.contents}>
                              <span className={styles.a}>
                                    <b className={styles.title}>관심 지역 인스타 팔로우</b> 만 해둬도
                              </span>
                              <div className={styles.innerContents}>
                                    <div className={styles.description}>
                                          <p className={styles.a}>
                                                1.
                                                <b className={styles.a1}> 매일 새로운 핫플</b>
                                                <span className={styles.span1}> 소개!</span>
                                          </p>
                                          <p className={styles.a}>
                                                2.
                                                <span className={styles.span1}> 매달</span>
                                                <b className={styles.a1}> 100명 추첨 → 1,000HP</b>
                                                <span className={styles.span1}> 지급!</span>
                                          </p>
                                    </div>

                                    <div className={styles.description1}>
                                          <div className={styles.badge2}>당첨 TIP</div>
                                          <p className={styles.a}>
                                                <b className={styles.span1}>게시글에 좋아요/AI 스크랩</b>
                                          </p>
                                          <p className={styles.a}>
                                                <b className={styles.span1}>할 수록</b>
                                                <span className={styles.a1}> 당첨 확률 UP!</span>
                                          </p>
                                    </div>

                                    <div className={styles.mapFrame}>

                                          <img className={styles.map} alt="" src="images/map.png" />
                                          {REGIONS.map(region => (
                                                regionImageComponent(region)
                                          ))}
                                    </div>
                              </div>
                        </div>
                  </div>
            </div>
      );
};

export default InstagramFollowModal;